import React from "react";
import "./style/contact.css";
import MapAddresse from "../home/mapAdresse"
import NewsLetter from "../home/newsLetter"
import Menu from "../home/Menu"
import Footer from "../home/footer"
import { Grid, Row, Col } from "react-flexbox-grid";
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import SideList from "./../home/SideList";
import Popup from "reactjs-popup";
import BurgerIcon from "../home/BurgerIcon";
import object_background from "../assets/header_bg/bgContact.png";
import {  UncontrolledAlert,Alert} from 'reactstrap';
import axios from 'axios';
import { Helmet } from "react-helmet";


import TagManager from "react-gtm-module";

// const tagManagerArgs = {
//   dataLayer: {
//     userProject: "Chifco_website",
//     page: "Contact",
//   },
//   dataLayerName: "PageDataLayer",
// };

const contentStyle = {
    position: "relative",
    background: "linear-gradient(to right, #0c0abe , #07054c)", 
    border: "none",
    width: "100%",
    textAlign: "center",
    padding: "0px !important",
    marginLeft: "auto",
    marginRight: "auto",
    marginTop: "80px",
    paddingBottom: "100%"
  
  };

 


class Contact extends React.Component {
    constructor(props) {
        super(props);
    
        this.onChangeFirstname = this.onChangeFirstname.bind(this);
        this.onChangeLastname = this.onChangeLastname.bind(this);
        this.onChangeEmail = this.onChangeEmail.bind(this);
        this.onChangeMessage=this.onChangeMessage.bind(this);
        this.onChangeNumber=this.onChangeNumber.bind(this);
        this.onSubmit=this.onSubmit.bind(this);
      
        this.state = {
          show :false,
          firstname: '',
          lastName: '',
          email: '',
          number:0,
          message:'',
         
           };
      }
      componentDidMount(){
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    
       onChangeFirstname(e) {
        this.setState({
          Firstname: e.target.value
        })
      }
    
      onChangeLastname(e) {
        this.setState({
          Lastname: e.target.value
        })
      }
      
    
      onChangeEmail(e) {
        this.setState({
          Email: e.target.value
        })
      }
    
      onChangeMessage(e) {
        this.setState({
         Message: e.target.value
        })
      }
    
      onChangeNumber(e) {
        this.setState({
          number: e.target.value
        })
      }
      
     
       
        
     
    
     onSubmit(e) {
      e.preventDefault();
    
       const  data = {
       Email: this.state.Email,
       number: this.state.number,
       Message: this.state.Message,
       Firstname:this.state.Firstname,
       Lastname:this.state.Lastname
       }
       axios.post(`${process.env.REACT_APP_SERVER}`+'/clients/add', data)
       .then(res => {
        this.setState({isCliked : !this.state.isCliked ,
          show :!this.state.show })
      })
       .catch((error) => {
          console.log(error);
        })
    
      }
    
  
    render() {
      //TagManager.dataLayer(tagManagerArgs)
  
        return (
            <div>
                <Helmet>
          <meta charSet="utf-8" />
          <title>Contact</title>
          <link
            rel="canonical"
            href={
              //"https://chifcositev2.chifco.com" +
              process.env.REACT_APP_CLIENT + "/contact"
            }
          />
        </Helmet>

                <div className="banniereContact">
                 {/*Menu horizontal Web*/}
                <div className="menu-horizontal">
                    <Menu />
                </div>
                {/*Menu Responsive Popup*/}
                <div className="menuMobile">
                    <Popup
                        modal
                        overlayStyle={{  background: "linear-gradient(to right, #0c0abe , #07054c)",  width: "100%" }}
                        contentStyle={contentStyle}
                        closeOnDocumentClick={false}
                        trigger={open => <BurgerIcon open={open} />}
                    >
                    <SideList />
                    </Popup>
                </div>
                <div className="textBanniereContact">
                    <h1 className="sliderTitleContact">DITES-NOUS <br /><b style={{ color: "#ffd904" }}>BONJOUR !</b></h1>
                    <div className="imgContactbg">
                        <img className="imageBaniereContact" src={object_background} alt="" />
                    </div>
                </div>
                </div>
                <div className="contactForm">
                    <div>
                        <h1 className="contactTitle">CONTACTEZ-NOUS</h1>
                    </div>
                   
                    <Grid fluid style={{ width: "60%", marginLeft: "auto" ,  marginRight: "auto"}} >
                    <form onSubmit={this.onSubmit}>
                        <Row >
                            <Col xs={12} md={6} lg={6} style={{maxWidth: "100%"}}>

                                <TextField
                                required
                                label="Firstname"
                                margin="normal"
                                style={{width: "100%"}}
                                value={this.Firstname}
                                onChange={this.onChangeFirstname}

                                />
                    
                            </Col> 
                            <Col xs={12} md={6} lg={6}  style={{maxWidth: "100%"}}> 

                                <TextField
                                label="Lastname"
                                required
                                style={{width: "100%"}}
                                margin="normal"
                                value={this.Lastname}
                                onChange={this.onChangeLastname}
                                />
                                
                            </Col>
                            <Col xs={12} md={6} lg={6} style={{maxWidth: "100%"}}>

                                <TextField
                                label="Email"
                                required
                                style={{width: "100%"}}
                                type="email"
                                autoComplete="email"
                                margin="normal"
                                value={this.Email}
                                onChange={this.onChangeEmail}
                                />
                
                            </Col>
                            <Col xs={12} md={6} lg={6} style={{maxWidth: "100%"}}> 

                                <TextField
                                label="Number"
                                required
                                style={{width: "100%"}}
                                margin="normal"
                                type="number"
                                />
                                
                            </Col>
                            <Col xs={12} md={12} lg={12}> 
                                <TextField 
                                    style={{width: "100%"}}
                                    label="Message"
                                    multiline
                                    required
                                    rows="4"
                                    margin="normal"
                                    value={this.Message}
                                onChange={this.onChangeMessage}
                                />
                        </Col>
                         
                     <p  style={{ color: "#0984e3" ,fontSize:"15px",fontStyle:"italic"}}>* Nous avons besoin des informations de contact que vous nous fournissez pour vous contacter à propos
                       de nos produits et services. Vous pouvez vous désinscrire de ces communications à tout moment.</p>
                        </Row>
                        <Row>
                        <Button type="submit" style={{backgroundColor:"rgb(255, 217, 4)",boxShadow:"unset",backgroundImage:"none",border:"none",color:"rgba(0, 0, 0, 0.87)",padding:"5px",borderRadius:"unset",display:"flex",fontSize:"revert",content:"none", fontWeight:"inherit" , marginTop:"inherit"}}
                        >
                            Envoyer
                        </Button> 
                        </Row>
                   
                        </form>
                       
                    </Grid>
                    {this.state.show && <Msg/>}
                   
                </div>
               
                <MapAddresse />
                <NewsLetter />
                <Footer />
            </div>
        );
    }
}
class Msg extends React.Component {
    render(){
      return(
  
  <UncontrolledAlert style={{ color: "#a6c19a", backgroundColor:"#2c38b5" , width:"450px", height:"50px", paddingTop:"15px", paddingLeft:"50px",marginLeft:"900px", marginTop:"30px"}}  >
   <span>
       Your Message has been send successfully 
       </span>
  </UncontrolledAlert>
      )}
  }
export default Contact;


// WEBPACK FOOTER //
// ./src/pages/contact.js